<div id="electricPhase" class="container mx-auto" data-cy="electric-phase">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.title' | translate"
      [subtitle]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.description' | translate"
      data-cy="electric-phase-title"
    ></ife-title>

    <div class="flex flex-wrap md:mt-8 justify-center">
      <ife-checkbox
        [id]="electricPhase.singlePhase"
        [attr.data-cy]="electricPhase.singlePhase"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        [value]="electricPhase.singlePhase"
        formControlName="electricPhase"
        [image]="'./assets/evc/img/singlePhase.svg'"
        [caption]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.singlePhase.title' | translate"
      >
      </ife-checkbox>
      <ife-checkbox
        [id]="electricPhase.threePhase"
        [attr.data-cy]="electricPhase.threePhase"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        [value]="electricPhase.threePhase"
        formControlName="electricPhase"
        [image]="'./assets/evc/img/threePhase.svg'"
        [caption]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhase.title' | translate"
      >
      </ife-checkbox>
      <ife-checkbox
        [id]="electricPhase.threePhaseNeutral"
        [attr.data-cy]="electricPhase.threePhaseNeutral"
        class="w-full mb-8 sm:w-auto"
        [value]="electricPhase.threePhaseNeutral"
        formControlName="electricPhase"
        [image]="'./assets/evc/img/threePhaseNeutral.svg'"
        [caption]="
          'modules.evSimulator.steps.electricPhase.fields.electricPhase.options.threePhaseNeutral.title' | translate
        "
      >
      </ife-checkbox>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      [showSetDefault]="!control.valid"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
      (defaultValue)="setDefaultValue()"
    >
    </ife-navigation>
  </div>
</div>
<div class="bg-white md:pt-8 px-8 mt-8 flex-grow">
  <div class="flex flex-wrap justify-center">
    <div id="help" data-cy="electric-phase-help" class="mx-auto mt-16 text-left sm:text-center max-w-7xl">
      <h3 [innerHTML]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.help.title' | translate"></h3>
      <div class="my-8 sm:mx-auto body-base text-grey-dark opacity-90">
        <span
          [innerHTML]="'modules.evSimulator.steps.electricPhase.fields.electricPhase.help.description' | translate"
        ></span>
      </div>
    </div>
  </div>

  <ng-template #slide let-config="config">
    <div class="help-table-cell">
      <img [src]="config?.src" [alt]="config.title | translate" />
      <div class="my-auto">
        <span class="help-table-cell-title" [innerHTML]="config?.title | translate"></span>
        <span [innerHTML]="config?.description | translate"></span>
      </div>
    </div>
  </ng-template>

  <div
    data-cy="table"
    class="help-table hidden lg:grid grid-flow-col grid-cols-2 grid-rows-2 gap-y-5 m-auto px-16"
  >
    <div *ngFor="let config of slideConfig">
      <ng-template [ngTemplateOutlet]="slide" [ngTemplateOutletContext]="{ config: config }"></ng-template>
    </div>
  </div>
</div>

<!-- no right and left padding for the swiper, it needs to reach the edge of the screen -->
<div class="pb-8 lg:pb-16 bg-white">
  <swiper-container
    id="swiper"
    class="lg:max-w-screen-xl mb-12"
    data-cy="swiper"
    appSwiper
    #swiper
    [config]="swiperConfig"
    init="false"
  >
    <swiper-slide class="lg:hidden" *ngFor="let config of slideConfig">
      <ng-template [ngTemplateOutlet]="slide" [ngTemplateOutletContext]="{ config: config }"></ng-template>
    </swiper-slide>
  </swiper-container>
</div>
